import { render, staticRenderFns } from "./EditViewTermReportsSubjectRecords.vue?vue&type=template&id=a44e03ae&scoped=true"
import script from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
export * from "./EditViewTermReportsSubjectRecords.vue?vue&type=script&lang=js"
import style0 from "./EditViewTermReportsSubjectRecords.vue?vue&type=style&index=0&id=a44e03ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44e03ae",
  null
  
)

export default component.exports